export {
  getPlan,
  getPlanFeatures,
  getPlanPosFeatures,
  getPlanLimits,
  hasFeature,
  hasPosFeature,
  getIncludedPosAddon,
  getAddon,
  getAddonFeatures,
  getAddonFeatureFlags,
  getAllCoreFeatureKeys,
  getAllPosFeatureKeys,
  getMode,
  isLifecycleActive,
  getVolumeDiscount,
  getUpgradePath,
  getAllPlanCodes,
  getAllAddonCodes,
  getAllModeCodes,
  ALL_OPERATING_MODE_KEYS,
  getModeDisplay,
  getAllModeDisplays,
  getPosFeatureFlagDisplay,
  getAllPosFeatureFlagDisplays,
  getAllFeatures,
  resolveEntitlement,
  billingConfig,
  PLAN_CODES_TUPLE,
  PAID_PLAN_CODES_TUPLE,
} from './billing';

export {
  getRole,
  getRolePermissions,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getPosBundle,
  getPosBundlePermissions,
  getCoreDashboardPermissions,
  getOperationsPermissions,
  getPosPermissions,
  getCourierPermissions,
  getAiPermissions,
  isPosRole,
  isAssignableRole,
  getAllRoles,
  getAllPosBundles,
  applyInheritanceRules,
  permissionsConfig,
} from './permissions';

export {
  getAutomationCatalog,
  getAutomationTrigger,
  getAutomationAction,
  isAutomationTriggerAllowed,
  isAutomationActionAllowed,
  isAutomationItemEligible,
  resolveAutomationCatalog,
} from './ai-automations';

export {
  getSurface,
  getPosWorkspace,
  isSurfaceVisibleForType,
  resolveVisibleSurfaces,
  getNavSurfaces,
  getSurfaceReveal,
  getSurfaceRouteAliases,
  getBusinessType,
  getBusinessTypeQuickActions,
  getBusinessTypeReports,
  getBusinessTypeSubTypes,
  getBusinessTypePresetModes,
  getBusinessTypeVocabulary,
  getBusinessTypeComposition,
  getBusinessTypeAssumedEntitlements,
  getBusinessTypePosRequirements,
  getBusinessTypePresentation,
  getSubTypeProfile,
  getSubTypeOperationalComposition,
  getSidebarItems,
  getSidebarItemsForGroup,
  getSidebarItem,
  resolveVisibleSidebarItems,
  getHost,
  getHostMount,
  isHostLive,
  getInstallableHosts,
  getSidebarStructuralItems,
  getSidebarGroupOrder,
  getSidebarGroupLabels,
  getSidebarGroupConfig,
  getSidebarItemsForWorkspace,
  getPanels,
  getPanel,
  getMenuDisplayConfig,
  isValidMenuDisplayMode,
  resolveMenuDisplayMode,
  allSurfaces,
  allPosWorkspaces,
  allBusinessTypes,
  allSidebarItems,
  allSidebarGroups,
  allHosts,
  navSurfaces,
  homeActionKeys,
  navGroups,
  reportKeys,
} from './navigation';

export {
  POS_NAV_GROUP_ORDER,
  getPosNavGroups,
  getPosNavItem,
  resolvePosNavItems,
  resolvePosNavGroups,
} from './pos-navigation';

export {
  MODULE_STATES,
  MANIFEST_KEYS,
  MANIFEST_SUB_TYPES,
  ALL_SUB_TYPE_IDS,
  ALWAYS_ON_KEYS,
  ALWAYS_ON_SECTION_KEYS,
  WORKSPACE_KEYS,
  POS_LANE_KEYS,
  POS_ENTRY_KEY,
  POS_SECTION,
  isManifestSubType,
  businessTypeForSubType,
  getSubTypeManifest,
  posEntryFor,
  parentKeyOf,
  resolveModules,
  moduleState,
  isModuleAvailable,
  isModuleOn,
  offeredModules,
  enabledModules,
} from './module-manifest';

export {
  getTemplate,
  getAllTemplates,
  getDefaultTemplateForType,
  resolveBranchTemplate,
  getTemplateSuitableTypes,
  isTemplateId,
} from './templates';

export {
  getSystemTemplates,
  getSystemTemplate,
  isTemplateCode,
  getTemplatesForBusinessType,
  getTemplateCapabilityKeys,
  getTemplateWorkspaces,
  validateTemplateRegistry,
} from './team-templates';

export {
  getTeamJobs,
  getTeamJobByTemplate,
  getTeamJobForRole,
  PIN_JOB_TEMPLATE_CODES,
  type TeamJob,
  type TeamJobAccess,
  type PinJobTemplateCode,
} from './team-jobs';

export {
  getGlobalFlag,
  getPosFeatureFlags,
  getModeRequirement,
  isModeAvailable,
  getServerGateFunctions,
  getEligibilityContract,
  getDesignToken,
  getBreakpoint,
  getTouchTarget,
  getLayoutConfig,
  getRouteChrome,
  getComponentRegistry,
  getInteractionPattern,
  getMotionConfig,
  getAccessibilityConfig,
  featuresConfigRaw,
  uiConfigRaw,
} from './features-ui';

export type {
  PlanConfig,
  AddonConfig,
  ModeConfig,
  BillingPlansConfig,
} from './types';

export type { OperatingModeDisplay, PosFeatureFlagDisplay } from './billing';

export type {
  TeamPermissionKey,
  TeamRole,
  RoleConfig,
  PosBundleConfig,
} from './permissions';

export type {
  SurfaceDefinition,
  PosWorkspaceDefinition,
  BusinessTypeDefinition,
  BusinessTypeSubType,
  SubTypeOperationalComposition,
  SidebarItem,
  HostDefinition,
  MenuDisplayMode,
  MenuDisplayModeConfig,
  MenuDisplayConfig,
} from './navigation';

export type {
  PosNavGroupKey,
  PosNavGroupConfig,
  PosNavItemConfig,
  PosNavGroup,
  ResolvePosNavOptions,
} from './pos-navigation';

export type {
  ModuleState,
  PosEntryLane,
  SubTypeManifest,
  ModuleManifestConfig,
} from './module-manifest';

export type {
  TemplateId,
  TemplateColorPalette,
  TemplateTypography,
  TemplateLayout,
  TemplateComponents,
  BranchTemplate,
} from './types';

export type {
  AutomationCatalog,
  AutomationCatalogAction,
  AutomationCatalogTrigger,
  AutomationCatalogEligibilityInput,
  AutomationCatalogVerdict,
  AutomationCatalogParams,
  AutomationCatalogParamProperty,
} from './ai-automations';
